<div class="container mb-2">
  <nh-alert type="warning" [isOpen]="isConversionMode">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
          alt="warning"
        />
      </div>
      <div class="col message">
        <span>{{ "CONVERSION_STATUS" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  <div>
    <div
      id="step4"
      #step4
      joyrideStep="Step4"
      (next)="onNext()"
      stepPosition="left"
      text="{{
        (isMobileView && submissionStatusSwitch
          ? 'TUTORIAL_4_MOBILE'
          : 'TUTORIAL_4'
        ) | globalTranslate
      }}"
    >
      @if (isMobileView && submissionStatusSwitch) {
      <div class="mb-3 panel-height row ps-2 parentdiv">
        <div class="col-md-4 submission_status white-panel">
          <section>
            <h2 class="submission_header pb-3">
              {{ "MANAGE_YOUR_APP_HEADER" | globalTranslate }}
            </h2>
            <div class="sub-title">
              <span>{{ "MANAGE_YOUR_APPLICATIONS" | globalTranslate }}</span>
            </div>
            <div class="appstatus_container mt-3 text-align-center">
              <div class="sub_content">
                <img
                  class="app_status_icon"
                  [attr.aria-label]="'APPLICATION_STATUS' | globalTranslate"
                  src="../../../assets/images/Icons/Welcome_SearchSubmissions.svg"
                />
                <a
                  tabindex="0"
                  class="add-primary-color app_status"
                  (click)="goToSubmissionStatus()"
                  [ngClass]="{ link_text: translatedLang !== 'en' }"
                  >{{ "APPLICATION_STATUS" | globalTranslate }}</a
                >
              </div>
            </div>
          </section>
        </div>
      </div>
      }
      <div class="mb-3 panel-height row ps-2 parentdiv">
        @if (isMobileView && isAutoRenewModeDefault) {
        <div class="col-md-4 white-panels">
          <div>
            <h2 class="section-header">
              {{ "COVERAGE_AUTORENEWAL_STATUS" | globalTranslate }}
            </h2>
            <p
              class="pb-1"
              [innerHTML]="'START_AUTORENEWAL_STATIC' | globalTranslate"
            ></p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="toAutoRenewal()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "UPDATE_1" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (isAutoRenewModeDefault === true) {
        <div
          class="col-md-5 col-lg-4 d-none d-lg-block d-md-block white-panels flex_align"
        >
          @if (!isRenew) {
          <div class="app-status btn_align">
            <h2 class="section-header">
              {{ "COVERAGE_AUTORENEWAL_STATUS" | globalTranslate }}
            </h2>
            <p
              class="pb-1"
              [innerHTML]="'START_AUTORENEWAL_STATIC' | globalTranslate"
            ></p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="toAutoRenewal()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "UPDATE_1" | globalTranslate }}
              </button>
            </div>
          </div>
          }
        </div>
        } @if (appStatus === true && !isMobileView && !isRenew) {
        <div
          class="col-md-5 col-lg-4 d-none d-lg-block d-md-block white-panels flex_align"
        >
          @if (!isRenew) {
          <div class="app-status btn_align">
            <h2 class="section-header">
              {{ "COVERAGE_APPLICATION_STATUS" | globalTranslate }}
            </h2>
            <p class="pb-1">{{ "APP_IN_PROGRESS_TILE" | globalTranslate }}</p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="continueApp()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_APPLICATION_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
          }
        </div>
        } @if ( !isMobileView && isRenew) {
        <div
          class="col-md-5 col-lg-4 d-none d-lg-block d-md-block white-panels flex_align"
        >
          <div class="app-status btn_align">
            <h2 class="section-header">
              {{ "COVERAGE_RENEWAL_STATUS" | globalTranslate }}
            </h2>
            <p class="pb-1">{{ "APP_IN_PROGRESS_TILE" | globalTranslate }}</p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="continueApp()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_RENEWAL_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (appStatus !== true && !isMobileView && preterminprogress &&
        !isRenew) {
        <div
          class="col-md-5 col-lg-4 d-none d-lg-block d-md-block white-panels flex_align"
        >
          <div class="app-status btn_align">
            <h2 class="section-header">
              {{ "COVERAGE_PRT_STATUS" | globalTranslate }}
            </h2>
            <p
              class="pb-1"
              [innerHtml]="
                'COVERAGE_PRT_STATUS_2'
                  | translate
                  | replacedate: renewalDueDate:replaceText
                  | replacedate: preTermDueDate:replacePreTermDateText
                  | globalTranslate
                  | sanitize
              "
            ></p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary"
                (click)="continuePretermApp()"
                style="min-height: 85px; padding: 0; text-transform: none"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_PRETERM_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (appStatus === true && isMobileView && !isRenew) {
        <div class="col-md-4 white-panels">
          <div>
            <h2 class="section-header">
              {{ "COVERAGE_APPLICATION_STATUS" | globalTranslate }}
            </h2>
            <p class="pb-1">{{ "APP_IN_PROGRESS_TILE" | globalTranslate }}</p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="continueApp()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_APPLICATION_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (isEbmsUser && !isMobileView) {
        <div
          class="col-md-5 col-lg-4 d-none d-lg-block d-md-block white-panels flex_align"
          style="border: 3px solid rgba(176, 66, 70, 255)"
        >
          <div class="app-status btn_align">
            <h2 class="section-header">
              {{ "EBMS_NUDGE_HEADER" | globalTranslate }}
            </h2>
            <p
              class="pb-1"
              [innerHtml]="'EBMS_NUDGE_STATIC' | globalTranslate"
            ></p>
            <div class="actionbtn">
              <button
                id="ebmsNudge"
                class="w-100 btn btn-secondary capitalize-btn"
                style="height: 59px; padding: 0"
                (click)="onEBMSClick()"
                [disabled]="false"
              >
                {{ "COVERAGE_APPLICATION_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (isEbmsUser && isMobileView) {
        <div
          class="col-md-4 white-panels"
          style="border: 3px solid rgba(176, 66, 70, 255)"
        >
          <div>
            <h2 class="section-header">
              {{ "EBMS_NUDGE_HEADER" | globalTranslate }}
            </h2>
            <p
              class="pb-1"
              [innerHtml]="'EBMS_NUDGE_STATIC' | globalTranslate"
            ></p>
            <div class="actionbtn">
              <button
                id="ebmsNudge"
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="onEBMSClick()"
                style="height: 59px; padding: 0"
                [disabled]="false"
              >
                {{ "COVERAGE_APPLICATION_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        }
        <!--Health plan nudge when OE-->
        @if (mcoMasterSwitch) {
        <!-- nudge not shown electronic letters -->
        <!-- <div class="row"> -->
        @if (isHealthPlanChanged && !isPartnerApp && healthPlanOpenEnrollment &&
        !isWithinMcoNinetyDaysSw) {
        <div class="col-md-5 col-lg-4 white-panels childdiv flex_align">
          <h2
            [innerHtml]="
              'COVERAGE_OVERVIEW_HEADER_12' | globalTranslate | sanitize
            "
            class="section-header"
          ></h2>
          <p
            [innerHtml]="
              'COVERAGE_OVERVIEW_INFO_12' | globalTranslate | sanitize
            "
            class="pb-1"
          ></p>
          <div class="actionbtn">
            <button
              class="w-100 btn btn-secondary capitalize-btn"
              style="height: 59px; padding: 0"
              (click)="toChangeHealthPlan()"
              [disabled]="readTCC"
            >
              {{ "WELCOME_BTN" | globalTranslate }}
            </button>
          </div>
        </div>
        }
        <!-- </div> -->
        }
        <!--health plan nudge when within 90 day period-->
        <!--If member is in OE period and 90 day period, display 90 day nudge-->
        @if (mcoMasterSwitch) { @if (isHealthPlanChanged && !isPartnerApp &&
        isWithinMcoNinetyDaysSw) {
        <div class="col-md-5 col-lg-4 white-panels flex_align childdiv">
          <h2
            [innerHtml]="
              'COVERAGE_OVERVIEW_HEADER_15' | globalTranslate | sanitize
            "
            class="section-header"
          ></h2>
          <p
            [innerHtml]="
              'COVERAGE_OVERVIEW_INFO_12' | globalTranslate | sanitize
            "
            class="pb-1"
          ></p>
          <div class="actionbtn">
            <button
              class="w-100 btn btn-secondary capitalize-btn"
              (click)="toChangeHealthPlan()"
              style="height: 59px; padding: 0"
              [disabled]="readTCC"
            >
              {{ "WELCOME_BTN" | globalTranslate }}
            </button>
          </div>
        </div>
        } } @if (isMobileView && isRenew) {
        <div class="col-md-4 white-panels">
          <div>
            <h2 class="section-header">
              {{ "COVERAGE_RENEWAL_STATUS" | globalTranslate }}
            </h2>
            <p class="pb-1">{{ "APP_IN_PROGRESS_TILE" | globalTranslate }}</p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary capitalize-btn"
                (click)="continueApp()"
                style="height: 59px; padding: 0"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_RENEWAL_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @if (appStatus !== true && isMobileView && preterminprogress &&
        !isRenew) {
        <div class="col-md-4 white-panels">
          <div>
            <h2 class="section-header">
              {{ "COVERAGE_PRT_STATUS" | globalTranslate }}
            </h2>
            <p class="pb-1">{{ "APP_IN_PROGRESS_TILE" | globalTranslate }}</p>
            <div class="actionbtn">
              <button
                class="w-100 btn btn-secondary"
                (click)="continuePretermApp()"
                style="height: 59px; padding: 0; text-transform: none"
                [disabled]="readTCC"
              >
                {{ "COVERAGE_PRETERM_CONTINUE" | globalTranslate }}
              </button>
            </div>
          </div>
        </div>
        } @for (item of vals; track item) {
        <div class="col-md-5 col-lg-4 white-panels childdiv flex_align">
          <h2 class="section-header">{{ item.header | globalTranslate }}</h2>
          <p
            class="pb-1"
            [innerHtml]="
              item.text
                | translate
                | replacedate: renewalDueDate:replaceText
                | replacedate: preTermDueDate:replacePreTermDateText
                | replacedate: retroEligibilityCoverageStartDt:replaceRetroText
                | globalTranslate
                | sanitize
            "
          ></p>
          @if (item.button) {
          <div class="actionbtn">
            <button
              id="{{ item.id }}"
              class="w-100 btn btn-secondary capitalize-btn"
              [ngClass]="{
                'lang-sp':
                  translatedLang === 'sp' && item.id === 'uploadDocAppeal'
              }"
              style="height: 59px"
              [disabled]="readTCC"
              (click)="item.click()"
            >
              {{ item.button | globalTranslate }}
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
    @if (response && response.caseDetailsResponse) {
    <div class="card pb-2" style="width: 100%">
      <div class="card-body">
        <div class="household-data pt-3">
          <h2 class="section-header">
            <strong>{{ "COVERAGE_DETAILS_HEADER" | globalTranslate }}</strong>
          </h2>
          <hr />
          <p
            class="pb-1"
            [innerHTML]="'BENEFITDASHBOARD_LETTERS_STATIC1' | globalTranslate"
          ></p>
          <div class="table-padding">
            @if (!isMobileView) {
            <mat-accordion
              displayMode=""
              multi
              class="mat-table"
              is-open="true"
            >
              @for (item of dataSource; track item) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header class="mat-row panel-header">
                  <img
                    class="login-icon"
                    alt=""
                    src="../../../../assets/images/⚛️ icons-login-person.svg"
                  />
                  <div class="ps-2 mat-cell-panel-header">
                    <div class="mat-cell gap-name mb-1">{{ item.name }}</div>
                    <span class="mat-cell">{{
                      item.sortedCaserows[0]?.dob
                    }}</span
                    >,&nbsp;
                    <span class="mat-cell">{{
                      item.sortedCaserows[0]?.gender
                    }}</span>
                  </div>
                  <div style="width: 70%">
                    @for (i of item.tileCaserows; track i) {
                    <div
                      class="mat-cell pb-2"
                      [innerHtml]="i.statusMsg | globalTranslate"
                    ></div>
                    } @if (item.ltssMessage) {
                    <div class="mat-cell">
                      <span
                        [innerHtml]="addBreakIfNeeded(item.ltssMessage)"
                      ></span>
                      <nh-popover
                        [customClass]="'cdt-popover'"
                        [reduceIconSize]="true"
                        [content]="'LTSS_TOOLTIP' | globalTranslate"
                        class="ps-1"
                      ></nh-popover>
                    </div>
                    }
                  </div>
                </mat-expansion-panel-header>
                <ngx-datatable
                  #table
                  [rows]="item.sortedCaserows"
                  columnMode="force"
                  [headerHeight]="'auto'"
                  [rowHeight]="'auto'"
                >
                  <ngx-datatable-column
                    [name]="columns[0].name | globalTranslate"
                    [prop]="columns[0].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="columns[1].name | globalTranslate"
                    [prop]="columns[1].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="columns[2].name | globalTranslate"
                  >
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.status | globalTranslate }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="columns[3].name | globalTranslate"
                    [prop]="columns[3].prop"
                  >
                    <ng-template
                      let-column="column"
                      ngx-datatable-header-template
                    >
                      <span
                        [ngClass]="{
                          'heath-plan-tool-tip': translatedLang === 'en'
                        }"
                        >{{ column.name }}
                        <nh-popover
                          [customClass]="'cdt-popover'"
                          [content]="
                            'HEALTH_PLAN_POPOVER_INFO' | globalTranslate
                          "
                          class="ps-1"
                        ></nh-popover>
                      </span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [width]="160">
                    <ng-template
                      let-column="column"
                      ngx-datatable-header-template
                    >
                      <span class="sr-only">Action</span>
                    </ng-template>
                    <ng-template
                      ngx-datatable-cell-template
                      let-row="row"
                      let-rowIndex="rowIndex"
                    >
                      @if (row && row.appStatus !== null && (row.appStatus !==
                      'PE' && row.appStatus !== 'PP')) {
                      <div class="p-0 hover-red">
                        <a
                          tabindex="0"
                          class="p-0 hover-red btn btn-link text-start"
                          (click)="getDetails(row)"
                          ><span class="view_details">{{
                            "CMB_VIEW_DETAILS" | globalTranslate
                          }}</span></a
                        >
                      </div>
                      }
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </mat-expansion-panel>
              } @if (!dataSource?.length) {
              <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
              }
            </mat-accordion>
            }
            <!-- mobile coverage details table -->
            @if (isMobileView) {
            <mat-accordion
              displayMode=""
              multi
              class="mat-table"
              is-open="true"
            >
              @for (item of dataSource; track item) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header class="mat-row panel-header-mobile">
                  <img
                    class="login-icon"
                    alt=""
                    src="../../../../assets/images/⚛️ icons-login-person.svg"
                  />
                  <span class="mat-cell ps-2 gap-name mb-2">{{
                    item.name
                  }}</span>
                  <span class="mat-cell">{{ item.sortedCaserows[0]?.dob }}</span
                  >,&nbsp;
                  <span class="mat-cell">{{
                    item.sortedCaserows[0]?.gender
                  }}</span>
                  <div class="statusMsg_mobile">
                    @for (i of item.tileCaserows; track i) {
                    <div
                      class="mat-cell pb-2"
                      [innerHtml]="i.statusMsg | globalTranslate"
                    ></div>
                    } @if (item.ltssMessage) {
                    <div class="mat-cell">
                      <span
                        [innerHtml]="
                          addBreakIfNeeded(item.ltssMessage) | globalTranslate
                        "
                      ></span>
                      <nh-popover
                        [reduceIconSize]="true"
                        [content]="'LTSS_TOOLTIP' | globalTranslate"
                        class="ps-1"
                      ></nh-popover>
                    </div>
                    }
                  </div>
                </mat-expansion-panel-header>
                <div class="nh-table-mobile pt-5 d-block">
                  @for (row of item.sortedCaserows; track row) {
                  <div class="table-row mb-3 pb-3">
                    <div class="mobile-table-header">
                      {{ displayedColumns[0] | globalTranslate }}
                    </div>
                    <hr />
                    <div class="mobile-table-data">{{ row.caseNum }}</div>
                    <br />
                    <div class="mobile-table-header">
                      {{ displayedColumns[1] | globalTranslate }}
                    </div>
                    <hr />
                    <div class="mobile-table-data">{{ row.coverageType }}</div>
                    <br />
                    <div class="mobile-table-header">
                      {{ displayedColumns[2] | globalTranslate }}
                    </div>
                    <hr />
                    <div class="mobile-table-data">
                      {{ row.status | globalTranslate }}
                    </div>
                    <br />
                    <div class="mobile-table-header">
                      {{ displayedColumns[3] | globalTranslate }}
                      <nh-popover
                        [content]="'HEALTH_PLAN_POPOVER_INFO' | globalTranslate"
                        [customClass]="'cdt-popover'"
                        class="ps-1"
                      ></nh-popover>
                    </div>
                    <hr />
                    <div class="mobile-table-data">{{ row.health_plan }}</div>
                    <br />
                    @if (row && (row.appStatus !=='PE'&& row.appStatus !==
                    'PP')) {
                    <button
                      id="coverageDetailsMob"
                      class="btn btn-outline-secondary"
                      (click)="getDetails(row)"
                    >
                      {{ "CMB_VIEW_DETAILS" | globalTranslate }}
                    </button>
                    }
                  </div>
                  }
                </div>
              </mat-expansion-panel>
              } @if (!dataSource?.length) {
              <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
              }
            </mat-accordion>
            }
          </div>
          @if (kbRows.length > 0) {
          <div>
            <h2 class="section-header">Katie Beckett Appointments</h2>
            <hr />
            @if (!isMobileView) {
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="kbRows"
              [columnMode]="'force'"
              [headerHeight]="'auto'"
              [footerHeight]="50"
              [rowHeight]="'auto'"
            >
              @for (col of kbColumns; track col) {
              <ngx-datatable-column
                [name]="col.name | globalTranslate"
                [prop]="col.prop"
              >
              </ngx-datatable-column>
              }
            </ngx-datatable>
            } @if (isMobileView) {
            <div>
              @for (row of kbRows; track row) {
              <div>
                <p>
                  <strong>{{ kbColumns[0].name | globalTranslate }}</strong>
                </p>
                <hr />
                <p>{{ row.name }}</p>
                <br />
                <hr />
                <p>
                  <strong>{{ kbColumns[1].name | globalTranslate }}</strong>
                </p>
                <hr />
                <p>{{ row.aptDate }}</p>
                <br />
                <p>
                  <strong>{{ kbColumns[2].name | globalTranslate }}</strong>
                </p>
                <hr />
                <p>{{ row.aptTime }}</p>
                <br />
                <p>
                  <strong>{{ kbColumns[3].name | globalTranslate }}</strong>
                </p>
                <hr />
                <p>{{ row.type }}</p>
                <br />
                <p>
                  <strong>{{ kbColumns[4].name | globalTranslate }}</strong>
                </p>
                <hr />
                <p>{{ row.address | globalTranslate }}</p>
                <br />
                @if (!kbRows.length) {
                <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
                }
              </div>
              }
            </div>
            }
          </div>
          } @if (kbPremiumRows.length > 0) {
          <div>
            <h2 class="section-header">Katie Beckett Part A Premium Amount</h2>
            @if (!isMobileView) {
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="kbPremiumRows"
              [columnMode]="'force'"
              [headerHeight]="'auto'"
              [footerHeight]="50"
              [rowHeight]="'auto'"
            >
              @for (col of kbPremiumColumns; track col) {
              <ngx-datatable-column
                [name]="col.name | globalTranslate"
                [prop]="col.prop"
              >
              </ngx-datatable-column>
              }
            </ngx-datatable>
            } @if (isMobileView) {
            <div>
              @for (row of kbPremiumRows; track row) {
              <div>
                <p>
                  <strong>{{ kbPremiumColumns[0].name }}</strong>
                </p>
                <hr />
                <p>{{ row.fullName }}</p>
                <br />
                <hr />
                <p>
                  <strong>{{ kbPremiumColumns[1].name }}</strong>
                </p>
                <hr />
                <p>{{ row.premiumAmount }}</p>
                <br />
                <p>
                  <strong>{{ kbPremiumColumns[2].name }}</strong>
                </p>
                <hr />
                <p>{{ row.dueDate }}</p>
                <br />
                @if (!kbPremiumRows.length) {
                <p class="mb-5">No data to display</p>
                }
              </div>
              }
            </div>
            }
          </div>
          }
          <div class="my-3">
            <div
              (click)="showDetails = !showDetails"
              (keydown.enter)="showDetails = !showDetails"
              (keydown.space)="
                showDetails = !showDetails; $event.preventDefault()
              "
              tabindex="0"
              role="button"
              [attr.aria-expanded]="showDetails"
              [attr.aria-label]="
                ('CONTACT_INFO' | globalTranslate) +
                (showDetails ? ', expanded' : ', collapsed')
              "
              class="section-header d-flex justify-content-between align-items-center"
            >
              <span>{{ "CONTACT_INFO" | globalTranslate }}</span>
              @if (showDetails) {
              <span class="pe-3" aria-hidden="true"
                ><i class="fa fa-angle-up"></i
              ></span>
              } @if (!showDetails) {
              <span class="pe-3" aria-hidden="true"
                ><i class="fa fa-angle-down"></i
              ></span>
              }
            </div>
            <hr />
            @if (showDetails && response) {
            <div>
              <p>
                <strong>{{ "HOH_INFO" | globalTranslate }}</strong>
              </p>
              <div
                class="card pb-2 ng-star-inserted"
                style="margin-bottom: 16px"
              >
                <div class="card-body">
                  <div class="mt-3">
                    <strong>{{
                      "COVERAGE_CASE_NUMBER" | globalTranslate
                    }}</strong>
                  </div>
                  <span>{{ response.caseDetailsResponse.caseNum }}</span>
                  <div class="mt-3">
                    <strong>{{ "HOH_NAME" | globalTranslate }}</strong>
                  </div>
                  <div>
                    <span>{{
                      response.caseDetailsResponse?.hoHFirstName
                    }}</span>
                    @if (response.caseDetailsResponse?.hoHMiddleInitial) {
                    <span
                      >&nbsp;{{
                        response.caseDetailsResponse.hoHMiddleInitial
                      }}</span
                    >
                    }
                    <span
                      >&nbsp;{{
                        response.caseDetailsResponse?.hoHLastName
                      }}</span
                    >
                  </div>
                  @if (phoneNumber) {
                  <div>
                    <div class="mt-3">
                      <strong>{{ "PRIMARY_PHN" | globalTranslate }}</strong>
                    </div>
                    <div>{{ phoneNumber | phone }}</div>
                  </div>
                  } @if (email) {
                  <div class="mt-3">
                    <strong>{{ "EMAIL" | globalTranslate }}</strong>
                  </div>
                  }
                  <div>{{ email }}</div>
                  @for (item of response.caseDetailsResponse.addressResponse;
                  track item) {
                  <div>
                    @if (item.addressType != 'AA') {
                    <div>
                      <div class="mt-3">
                        <strong>{{
                          item?.addressType == "PA"
                            ? ("HOME_ADDRESS" | globalTranslate)
                            : ("MAILING_ADDRESS" | globalTranslate)
                        }}</strong>
                      </div>
                      <div>
                        {{ item?.addressLine1 }} @if (item?.addressLine2) {
                        <span>{{ item?.addressLine2 }}</span>
                        }
                      </div>
                      @if (!item?.zip4) {
                      <div class="d-flex">
                        @if (item?.city) {
                        <span>
                          {{
                            item?.city + ", " + item?.state + " " + item?.zip5
                          }}
                        </span>
                        } @if (!item?.city) {
                        <span>
                          {{ item?.zip5 }}
                        </span>
                        }
                      </div>
                      } @if (item?.zip4) {
                      <div class="d-flex">
                        @if (item?.city) {
                        <span>
                          {{
                            item?.city +
                              ", " +
                              item?.state +
                              " " +
                              item?.zip5 +
                              "-" +
                              item?.zip4
                          }}
                        </span>
                        } @if (!item?.city) {
                        <span>
                          {{ item?.zip5 + "-" + item?.zip4 }}
                        </span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
            } @if (response && assistingDetails?.assistingPersonFirstName) {
            <div class="mt-2 assisting">
              @if (!assisting) {
              <small class="mb-2" (click)="assisting = true"
                ><u>{{ "VIEW_MORE" | globalTranslate }}</u>
              </small>
              }
              <div [hidden]="!assisting">
                <p class="small titleSpace">
                  <strong>{{
                    "ASSISTING_PERSON_INFO" | globalTranslate
                  }}</strong>
                </p>
                <div class="mt-3 small">
                  <strong>{{ "NAME" | globalTranslate }}</strong>
                </div>
                <div>
                  <span>{{
                    assistingDetails?.assistingPersonFirstName + " "
                  }}</span>
                  <span>{{ assistingDetails?.assistingPersonLastName }}</span>
                </div>
                @if (assistingDetails) {
                <div>
                  @if (assistingDetails.cellPhone) {
                  <div>
                    <div class="mt-3 small">
                      <strong>{{ "PRIMARY_PHN" | globalTranslate }}</strong>
                    </div>
                    <div>
                      <span>{{ assistingDetails?.cellPhone }}</span>
                    </div>
                  </div>
                  } @if (!assistingDetails.cellPhone &&
                  assistingDetails.homePhone) {
                  <div>
                    <div class="mt-3 small">
                      <strong>{{ "PRIMARY_PHN" | globalTranslate }}</strong>
                    </div>
                    <div>
                      <span>{{ assistingDetails?.homePhone }}</span>
                    </div>
                  </div>
                  } @if (!assistingDetails.cellPhone &&
                  !assistingDetails.homePhone && assistingDetails.workPhone) {
                  <div>
                    <div class="mt-3 small">
                      <strong>{{ "PRIMARY_PHN" | globalTranslate }}</strong>
                    </div>
                    <div>
                      <span>{{ assistingDetails?.workPhone }}</span>
                    </div>
                  </div>
                  }
                </div>
                } @if (assistingDetails?.emailAdd) {
                <div class="mt-3 small">
                  <strong>{{ "EMAIL" | globalTranslate }}</strong>
                </div>
                }
                <div>
                  <span>{{ assistingDetails?.emailAdd }}</span>
                </div>
                @if (assistingPersonAddress[0]) {
                <div>
                  <div class="mt-3 small">
                    <strong>{{ "HOME_ADDRESS" | globalTranslate }}</strong>
                  </div>
                  <div>
                    {{ assistingPersonAddress[0]?.addressLine1 }} @if
                    (assistingPersonAddress[0]?.addressLine2) {
                    <span>{{ assistingPersonAddress[0]?.addressLine2 }}</span>
                    }
                  </div>
                  <div class="d-flex">
                    <div class="d-flex">
                      @if (assistingPersonAddress[0]?.city) {
                      <span>
                        {{
                          assistingPersonAddress[0]?.city +
                            ", " +
                            assistingPersonAddress[0]?.state
                        }}
                        &nbsp;
                      </span>
                      } @if (assistingPersonAddress[0]?.zip5) {
                      <span>
                        {{ assistingPersonAddress[0]?.zip5 }}
                      </span>
                      } @if (assistingPersonAddress[0]?.zip4) {
                      <span> - {{ +assistingPersonAddress[0]?.zip4 }} </span>
                      }
                    </div>
                  </div>
                </div>
                } @if (assistingDetails) {
                <div>
                  <div class="mt-3 small">
                    <strong>{{
                      "ROLES_RESPONSIBILITIES" | globalTranslate
                    }}</strong>
                  </div>
                  @if (assistingDetails.assistingPersonApplicationSW &&
                  assistingDetails.assistingPersonApplicationSW == 'Y') {
                  <div>
                    <span>{{ "SIGN_BEHALF_SUBMIT_1" | globalTranslate }}</span>
                  </div>
                  } @if (assistingDetails.assistingPersonRenewalSW &&
                  assistingDetails.assistingPersonRenewalSW == 'Y') {
                  <div>
                    <span>{{ "SIGN_BEHALF_SUBMIT_2" | globalTranslate }}</span>
                  </div>
                  } @if (assistingDetails.assistingPersonNoticesSW &&
                  assistingDetails.assistingPersonNoticesSW == 'Y') {
                  <div>
                    <span>{{ "SIGN_BEHALF_SUBMIT_3" | globalTranslate }}</span>
                  </div>
                  } @if (assistingDetails.assistingPersonActOnBehalfSW &&
                  assistingDetails.assistingPersonActOnBehalfSW == 'Y') {
                  <div>
                    <span>{{ "SIGN_BEHALF_SUBMIT_4" | globalTranslate }}</span>
                    <ul
                      class="list-inline form-check-label"
                      style="padding-left: 2rem"
                    >
                      <li>{{ "YOUR_BEHALF_1" | globalTranslate }}</li>
                      <li>{{ "YOUR_BEHALF_2" | globalTranslate }}</li>
                      <li>{{ "YOUR_BEHALF_3" | globalTranslate }}</li>
                    </ul>
                  </div>
                  }
                </div>
                }
              </div>
              @if (assisting) {
              <small class="mt-3 mb-2" (click)="assisting = false"
                ><u>{{ "VIEW_LESS" | globalTranslate }}</u></small
              >
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>